module.exports = __webpack_public_path__ + "img/the-lion-tamer-v2.099d1d26.svg";